module.exports = __webpack_public_path__ + "img/computer-girl.d17b6d51.png";